// Multicolor artwork keeps its own colors, so it ships as hashed files rendered through `<img>`.
// Pass `import.meta.glob(..., { eager: true, query: '?no-inline', import: 'default' })` results here.
export function assetUrls(urls: Record<string, string>) {
  const byName = new Map(
    Object.entries(urls).map(([path, url]) => [path.slice(path.lastIndexOf('/') + 1, -'.svg'.length), url]),
  )

  return (name: string) => {
    const url = byName.get(name)
    if (!url) {
      throw new Error(`Unknown SVG asset: ${name}`)
    }
    return url
  }
}
